import {
	AddFormFieldOptionsRequest,
	AddFormFieldsRequest,
	BulkUpdateFormFieldsRequest,
	AddFieldDraft,
	FormDefinitionDetail,
	FormDefinitionSummary,
} from '../types/Form/FormDefinition'
import { FormSubmissionRequest, FormSubmissionResponse } from '../types/Form/FormSubmission'
import { deleteOne, getAll, getOne, patch, post, postWithResponse, put } from './CommonServices/httpService'

export async function listFormDefinitions(): Promise<FormDefinitionSummary[]> {
	const res = await getAll<FormDefinitionSummary[]>(`/FormDefinitions/All`, 'List form definitions failed')
	return res.data
}

export async function getFormDefinition(formDefinitionId: number): Promise<FormDefinitionDetail> {
	const res = await getOne<FormDefinitionDetail>(
		`/FormDefinitions/${formDefinitionId}`,
		'Get form definition failed',
	)
	return res.data
}

export async function getFormDefinitionByKey(formKey: string, projectId: number): Promise<FormDefinitionDetail> {
	const res = await getOne<FormDefinitionDetail>(
		`/FormDefinitions?formKey=${formKey}&projectId=${projectId}`,
		'Get form definition failed',
	)
	return res.data
}
export async function addFormFields(
	formDefinitionId: number,
	request: AddFieldDraft[],
): Promise<void> {
	const payload = request.map((d) => ({
		fieldKey: (d.label ?? '').trim(),
		label: (d.label ?? '').trim(),
		sectionName: (d.sectionName ?? '').trim(),
		fieldType: d.fieldType,
		isHidden: d.isHidden,
		isRequired: d.isHidden ? false : d.isRequired,
		placeholder: d.placeholder,
		options:
			d.fieldType === 'dropdown'
				? (d.dropdownOptions ?? [])
						.map((x) => (x ?? '').trim())
						.filter(Boolean)
						.map((x) => ({ value: x }))
				: null,
	}))

	await post(`/FormDefinitions/${formDefinitionId}/fields`, payload, 'Add form fields failed')
}

export async function bulkUpdateFormFields(
	formDefinitionId: number,
	request: BulkUpdateFormFieldsRequest,
): Promise<void> {
	await patch(`/FormDefinitions/${formDefinitionId}/fields`, request, 'Bulk update form fields failed')
}

export async function deleteFormField(formDefinitionId: number, fieldId: number): Promise<void> {
	await deleteOne(
		`/FormDefinitions/${formDefinitionId}/fields/${fieldId}`,
		'Delete form field failed',
	)
}

export async function addFormFieldOptions(
	formDefinitionId: number,
	fieldId: number,
	request: AddFormFieldOptionsRequest,
): Promise<void> {
	await post(
		`/FormDefinitions/${formDefinitionId}/fields/${fieldId}/options`,
		request,
		'Add form field options failed',
	)
}

export async function deleteFormFieldOption(
	formDefinitionId: number,
	fieldId: number,
	optionId: number,
): Promise<void> {
	await deleteOne(
		`/FormDefinitions/${formDefinitionId}/fields/${fieldId}/options/${optionId}`,
		'Delete form field option failed',
	)
}

export async function submitFormSubmission(
	formDefinitionId: number,
	request: FormSubmissionRequest,
): Promise<FormSubmissionResponse> {
	const res = await postWithResponse<FormSubmissionResponse>(
		`/FormDefinitions/${formDefinitionId}/submissions`,
		request,
		'Submit form failed',
	)
	return res.data
}
// Only for Work Scope Registration form submissions
export async function updateFormSubmission(
	submissionId: number,
	request: FormSubmissionRequest,
): Promise<void> {
	await put(`/FormDefinitions/submissions/${submissionId}`, request, 'Update submission failed')
}

